import { useEffect, useState, forwardRef, useRef } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStateCompliances,
  saveStateCompliance,
  getEditDocument,
} from "../slice/workerComplianceSlice";
import { useNavigate } from "react-router-dom";

const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "image/png",
  "image/jpeg",
];


const WorkerAddCompliance = forwardRef((props, ref) => {
  /* ------------------ FORM STATE ------------------ */
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /* ------------------ STEP CONTROL ------------------ */
  const [step, setStep] = useState(1);
  const [apiResult, setApiResult] = useState(null);
  const nextStep = () => setStep((s) => Math.min(s + 1, 3));
  const prevStep = () => setStep((s) => Math.max(s - 1, 1));

  const { data: stateData, loading, error, editDocument } = useSelector(
    (state) => state.workerCompliance
  );
  const { userData } = useSelector(
    (state) => state.workerInfo
  );

  // useImperativeHandle(ref, () => ({
  //   reset() {
  //     setSelectedFile(null);
  //     setSelectedFiles({});
  //     setSuccessMessage("");
  //     setComplianceStatus(null);
  //     setSaving(false);
  //     setIsSubmitted(false);
  //   }
  // }));
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [saving, setSaving] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  // const [userData, setUserData] = useState(null);
  const token = localStorage.getItem("token");
  const isEditMode = Array.isArray(editDocument) && editDocument.length > 0;
  const complianceId = editDocument?.[0]?.id;
  const [educationLevel, setEducationLevel] = useState([]);
  const [saveLoading, setSaveLoading] = useState(false);
  const modalRef = useRef(null);
  const shouldRedirectRef = useRef(false);

  const [checks, setChecks] = useState({
    background: {},
    teacher: {},
    support_staff: {},
  });

  const [fingerprint, setFingerprint] = useState({
    file: null,
    fileUrl: "",       // from API
    expiration_date: "",
    is_approve: "",
    isUpdated: false,  // track if user changed anything
  });




  const states = userData?.states;

  console.log("states", states);

  // const closeComplianceModal = () => {
  //   const modalEl = document.getElementById("addComplianceModal");

  //   if (modalEl && window.bootstrap) {
  //     const modal = window.bootstrap.Modal.getInstance(modalEl);
  //     modal?.hide();
  //   }

  //   // 🔥 Force cleanup (fix black backdrop issue)
  //   document.body.classList.remove("modal-open");

  //   document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());

  //   // navigate('/panel');
  // };


  useEffect(() => {
    const modalEl = document.getElementById("addComplianceModal");
    if (!modalEl || !window.bootstrap) return;

    // Initialize modal once
    modalRef.current = new window.bootstrap.Modal(modalEl, {
      backdrop: true,
      keyboard: true,
    });

    const handleHidden = () => {
      // Reset body styles
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";

      // Remove any lingering backdrop
      document.querySelectorAll(".modal-backdrop").forEach(b => b.remove());
      document.body.classList.remove("modal-open");

      // Redirect only if Finish clicked
      if (shouldRedirectRef.current) {
        navigate("/panel");
        shouldRedirectRef.current = false;
      }
    };

    modalEl.addEventListener("hidden.bs.modal", handleHidden);

    return () => {
      modalEl.removeEventListener("hidden.bs.modal", handleHidden);
      modalRef.current?.dispose();
      modalRef.current = null;
    };
  }, [navigate]);




  useEffect(() => {
    if (!states || !token) return;

    dispatch(getEditDocument(token));
  }, [states, token, dispatch]);

  console.log("editDocument", editDocument);

  // useEffect(() => {
  //   if (editDocument?.education_level) {
  //     setEducationLevel(editDocument.education_level);
  //   }
  // }, [editDocument.education_level]);

  useEffect(() => {
  if (editDocument?.education_level) {
    // if it's a string, split by comma
    const levels = Array.isArray(editDocument.education_level)
      ? editDocument.education_level
      : editDocument.education_level.split(",").map(l => l.trim());
    setEducationLevel(levels);
  }
}, [editDocument.education_level]);


  useEffect(() => {
    if (!editDocument?.documents) return;

    const prefilled = {};

    Object.entries(editDocument.documents).forEach(([docKey, doc]) => {
      prefilled[docKey] = {
        file: null,
        fileUrl: doc.fileUrl,
        expiration_date: doc.expiration_date,
        is_approve: doc.is_approve,
        isUpdated: false,
      };
    });
    setSelectedFiles(prefilled);
  }, [editDocument]);


  useEffect(() => {
    if (!editDocument) return;

    setChecks({
      background: editDocument.background || {},
      teacher: editDocument.teacher || {},
      support_staff: editDocument.support_staff || {},
    });
  }, [editDocument]);

  useEffect(() => {
    if (!editDocument?.fingerprint) return;

    setFingerprint({
      file: editDocument.fingerprint.file,
      fileUrl: editDocument.fingerprint.fileUrl,
      expiration_date: editDocument.fingerprint.expiration_date,
      is_approve: editDocument.fingerprint.is_approve,
      isUpdated: false,
    });
  }, [editDocument]);



  // useEffect(() => {
  //   if (saveResponse?.success) {
  //     setSuccessMessage(saveResponse.message); // "State compliance saved successfully."
  //     setComplianceStatus(saveResponse.data); // { document_upload: true, ... }
  //   }
  // }, [saveResponse]);


  useEffect(() => {
    if (!states || !token) return;

    dispatch(fetchStateCompliances({ states, token }));
  }, [states, token, dispatch]);

  const makeDocKey = (name) => {
    return name
      .toLowerCase()
      .replace(/\//g, "")      // remove /
      .replace(/\s+/g, "_")    // space → _
      .replace(/[^a-z0-9_]/g, ""); // remove other special chars
  };

  /* ------------------ SUBMIT ------------------ */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (saveLoading) return;

    setSaveLoading(true);

    const formData = new FormData();

    // 🔹 ACTION PARAM
    formData.append("action", isEditMode ? "update" : "create");

    // 🔹 Needed in both cases
    formData.append("state_code", states);

    formData.append("education_level", educationLevel);

    let hasUpdatedDocs = false;

    Object.entries(selectedFiles).forEach(([docKey, data]) => {
      // CREATE → send everything
      if (!isEditMode) {
        if (data.file) {
          formData.append(`documents[${docKey}][file]`, data.file);
        }
        if (data.expiration_date) {
          formData.append(
            `documents[${docKey}][expiration_date]`,
            data.expiration_date
          );
        }
      }

      // UPDATE → send ONLY updated documents
      if (isEditMode && data.isUpdated) {
        hasUpdatedDocs = true;

        if (data.file) {
          formData.append(`documents[${docKey}][file]`, data.file);
        }
        if (data.expiration_date) {
          formData.append(
            `documents[${docKey}][expiration_date]`,
            data.expiration_date
          );
        }
      }
    });

    // ⛔ Prevent empty update
    if (isEditMode && !hasUpdatedDocs) {
      alert("No changes detected");
      return;
    }

    // 🔹 CREATE → include checks
    if (!isEditMode) {
      Object.entries(checks.background).forEach(([key, value]) => {
        formData.append(`checks[background][${key}]`, value);
      });

      Object.entries(checks.teacher).forEach(([key, value]) => {
        formData.append(`checks[teacher][teacher_${key}]`, value);
      });

      Object.entries(checks.support_staff).forEach(([key, value]) => {
        formData.append(`checks[support_staff][support_staff_${key}]`, value);
      });
    }

    // Fingerprint → send only if create or updated
    if (!isEditMode || fingerprint.isUpdated) {
      if (fingerprint.file) {
        formData.append("fingerprint", fingerprint.file);
        // formData.append("fingerprint_is_uploaded", 1);


      }
      // console.log("fingerprint.file",fingerprint.file);
      // console.log("length",editDocument.fingerprint);
      else if (!fingerprint.file && fingerprint.fileUrl) {
        formData.append("fingerprint_is_uploaded", 1);
      }
      if (fingerprint.expiration_date) {
        formData.append("fingerprint_expiration", fingerprint.expiration_date);
      }
    }



    const result = await dispatch(
      saveStateCompliance({ token, formData })
    );

    if (result.meta.requestStatus === "fulfilled") {
      // setSaving(true);
      // setTimeout(() => {
      //   setSaving(false);
      //   setIsSubmitted(true);
      // }, 3000);
      toast.success("Update Successful", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });

      console.log("result", result);
      console.log("result.payload", result.payload);

      // closeComplianceModal();

      setApiResult(result.payload);

      setStep(4)

      // navigate('/panel');
    } else {
      toast.error("Please fill all the required fields.", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
    }
    setSaveLoading(false);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading compliance</div>;
  if (!stateData) return null;

  const { role_id } = userData;

  /* ========================================================= */

  return (
    <div className="container mt-4">
      {/* ---------- PROGRESS ---------- */}
      <div className="mb-4">
        <div className="d-flex justify-content-between gap-2">
          {[1, 2, 3, 4].map((s) => {
            const isActive = step === s;
            const isCompleted = step > s;

            return (
              <div
                key={s}
                className={`flex-fill d-flex align-items-center gap-2 p-2 rounded fw-semibold
          ${isActive ? "bg-primary text-white" : ""}
          ${isCompleted ? "bg-primary text-white" : ""}
          ${!isActive && !isCompleted ? "bg-primary text-white" : ""}
        `}
              >
                {/* 🔵 Circle step number */}
                <div
                  className={`rounded-circle d-flex align-items-center justify-content-center fw-bold
            ${isActive ? "bg-white text-primary" : ""}
            ${isCompleted ? "bg-white text-primary" : ""}
            ${!isActive && !isCompleted ? "bg-white text-primary" : ""}
          `}
                  style={{ width: 32, height: 32 }}
                >
                  {s}
                </div>

                {/* Step label */}
                {/* <span>
                  {s === 1 ? "Eligibility" : s === 2 ? "Documents" : "Background"}
                </span> */}
                <span>
                  {s === 1
                    ? "Eligibility"
                    : s === 2
                      ? "Documents"
                      : s === 3
                        ? "Background"
                        : "Result"}
                </span>

              </div>
            );
          })}
        </div>



        <div className="progress mt-3" style={{ height: 7 }}>
          <div
            className="progress-bar"
            // style={{ width: `${step * 33.33}%` }}
            style={{ width: `${(step / 4) * 100}%`, backgroundColor: "#002b45" }}
          />
        </div>
      </div>
      <div className="form-section mt-3">
        {!isSubmitted && (
          <form onSubmit={(e) => {
            e.preventDefault(); // ❌ stop auto submit
          }}>
            {/* ---------- STEP 1 ---------- */}

            {step === 1 && (
              <>
                <div className="row g-3">


                  {/* Min Age */}
                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Minimum Age</label>
                    <input type="number" className="form-control" defaultValue={stateData.min_age} readOnly />
                  </div>

                  {/* Medical Clearance */}
                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Medical Clearance Required</label>
                    <input type="text" className="form-control" defaultValue={stateData.medical_clearance_required} readOnly />

                  </div>

                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Pending Clearance Allowed</label>
                    <input type="text" className="form-control" defaultValue={stateData.pending_clearance_allowed} readOnly />

                  </div>

                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Provisional Hire</label>
                    <input type="text" className="form-control" defaultValue={stateData.provisional_hire} readOnly />

                  </div>

                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Training initial hours</label>
                    <input type="number" className="form-control" defaultValue={stateData.training_initial_hours} readOnly />

                  </div>

                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Training annual hours</label>
                    <input type="number" className="form-control" defaultValue={stateData.training_annual_hours} readOnly />

                  </div>

                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold required">
                      Education Level
                    </label>

                    <div>
                      {stateData.education_levels.map((level, index) => (
                        <div className="form-check form-check-inline" key={index}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`education-${index}`}
                            value={level}
                            checked={educationLevel.includes(level)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setEducationLevel((prev) => [...prev, level]);
                              } else {
                                setEducationLevel((prev) =>
                                  prev.filter((item) => item !== level)
                                );
                              }
                            }}
                          />
                          <label className="form-check-label" htmlFor={`education-${index}`}>
                            {level}
                          </label>
                        </div>
                      ))}

                    </div>
                  </div>
                </div>
              </>
            )}

            {/* ---------- STEP 2 ---------- */}
            {step === 2 && (
              <>
                <h5 className="mb-3">Required Documents</h5>

                <div className="row g-3">
                  {stateData.documents.map((doc) => {
                    const docKey = makeDocKey(doc.document_name);

                    return (
                      <div className="col-md-6" key={doc.id}>
                        <div className="border border-dark rounded p-3 h-100">

                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="text-dark mb-0">{doc.document_name}</h6>
                            {doc.required ? (
                              <span className="badge bg-danger">Required</span>
                            ) : (
                              <span className="badge bg-info text-dark">Optional</span>
                            )}
                          </div>

                          <div className="row g-2">
                            {/* File Upload */}
                            <div className="col-9">
                              <label className="form-label text-primary mb-1 fw-semibold">
                                Document File
                              </label>

                              <div className="uploadfield">
                                <div className="custom-file-upload position-relative">
                                  <button
                                    type="button"
                                    className="upload-btn btn btn-light-header position-absolute"
                                    onClick={() =>
                                      document.getElementById(`docFile-${doc.id}`)?.click()
                                    }
                                  >
                                    Upload File
                                  </button>

                                  <input
                                    type="file"
                                    id={`docFile-${doc.id}`}
                                    hidden
                                    accept=".pdf,.png,.jpg,.jpeg"
                                    onChange={(e) => {
                                      const file = e.target.files[0] || null;

                                      if (file && !ALLOWED_FILE_TYPES.includes(file.type)) {
                                        alert("Only PDF, PNG, JPG files are allowed");
                                        e.target.value = "";
                                        return;
                                      }
                                      setSelectedFiles((prev) => ({
                                        ...prev,
                                        [docKey]: {
                                          ...prev[docKey],
                                          file,
                                          isUpdated: true,
                                        },
                                      }));
                                    }}
                                  />
                                </div>

                                <div className="file-name form-control text-truncate">
                                  {selectedFiles[docKey]?.file?.name || "No file chosen"}
                                </div>

                                {(selectedFiles[docKey]?.fileUrl || selectedFiles[docKey]?.file) && (
                                  <div className="mt-1">
                                    <a
                                      href={
                                        selectedFiles[docKey]?.file
                                          ? URL.createObjectURL(selectedFiles[docKey].file)
                                          : selectedFiles[docKey].fileUrl
                                      }
                                      target="_blank"
                                      rel="noreferrer"
                                      className="text-primary text-decoration-underline small"
                                    >
                                      View Uploaded File
                                    </a>
                                    <span
                                      className={`badge ${selectedFiles[docKey]?.is_approve === "yes" ? "bg-success" : "bg-secondary"} ms-2`}
                                    >
                                      {selectedFiles[docKey]?.is_approve === "yes" ? "Acknowledged" : "Not Acknowledged"}
                                    </span>

                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Expiration Date */}
                            <div className="col-3">
                              <label className="form-label text-primary mb-1 fw-semibold">
                                Expiration Date
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                value={selectedFiles[docKey]?.expiration_date || ""}
                                onChange={(e) => {
                                  setSelectedFiles((prev) => ({
                                    ...prev,
                                    [docKey]: {
                                      ...prev[docKey],
                                      expiration_date: e.target.value,
                                      isUpdated: true,
                                    },
                                  }));
                                }}
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {/* ---------- STEP 3 ---------- */}
            {step === 3 && (
              <>
                {/* STATE CHECK */}
                <div className="row g-3">
                  <div className="col-12 mt-4">
                    <h5 className="text-primary">State Background Check</h5>
                  </div>

                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Fingerprint Required</label>
                    <input type="text" className="form-control" defaultValue={stateData.state_check.fingerprint_required} readOnly />
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Fingerprint Method</label>
                    <input type="text" className="form-control" defaultValue={stateData.state_check.fingerprint_method} readOnly />
                  </div>

                  <div className="col-md-6">
                    <div className="d-flex align-items-center mb-1">
                      <label className="form-label text-primary mb-0 font-weight-semibold">
                        Fingerprint Document
                      </label>

                      {fingerprint.is_approve && (
                        <span
                          className={`badge ${fingerprint.is_approve === "yes" ? "bg-success" : "bg-secondary"} ms-2`}
                        >
                          {fingerprint.is_approve === "yes" ? "Acknowledged" : "Not Acknowledged"}
                        </span>
                      )}
                    </div>

                    <div className="uploadfield flex-fill">
                      <div className="custom-file-upload position-relative">
                        <button
                          type="button"
                          className="upload-btn btn btn-light-header position-absolute"
                          onClick={() =>
                            document.getElementById("docFile-fingerprint")?.click()
                          }
                        >
                          Upload File
                        </button>

                        <input
                          type="file"
                          id="docFile-fingerprint"
                          hidden
                          accept=".pdf,.png,.jpg,.jpeg"
                          onChange={(e) => {
                            const file = e.target.files[0] || null; // <-- binary file

                            if (file && !ALLOWED_FILE_TYPES.includes(file.type)) {
                              alert("Only PDF, PNG, JPG files are allowed");
                              e.target.value = "";
                              return;
                            }
                            setFingerprint((prev) => ({
                              ...prev,
                              file,          // store selected file here
                              isUpdated: true
                            }));
                          }}
                        />
                      </div>

                      <div
                        className="file-name form-control text-truncate"
                        title={fingerprint.file?.name || fingerprint.fileUrl || ""}
                      >
                        {fingerprint.file
                          ? fingerprint.file.name
                          : fingerprint.fileUrl
                            ? <a href={fingerprint.fileUrl} target="_blank" rel="noreferrer" className="text-primary text-decoration-underline">View Uploaded File</a>
                            : "No file chosen"}
                      </div>

                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">
                      Expiration Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={fingerprint.expiration_date || ""}
                      onChange={(e) =>
                        setFingerprint((prev) => ({
                          ...prev,
                          expiration_date: e.target.value,
                          isUpdated: true
                        }))
                      }
                    />
                  </div>

                  <div className="row g-3">
                    {/* LEFT COLUMN — Background Checks */}
                    <div className="col-sm-6">
                      <label className="form-label text-primary mb-2 font-weight-semibold">
                        Background Checks
                      </label>

                      {stateData.state_check.background_checks.map((check, index) => (
                        <div className="form-check form-switch mb-2" key={index}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={`background-${check}`}
                            checked={!!checks.background[check]}
                            onChange={(e) =>
                              setChecks((prev) => ({
                                ...prev,
                                background: {
                                  ...prev.background,
                                  [check]: e.target.checked,
                                },
                              }))
                            }
                          />
                          <label
                            className="form-check-label text-primary font-weight-semibold"
                            htmlFor={`background-${check}`}
                          >
                            {check} Check
                          </label>
                        </div>
                      ))}
                    </div>

                    {/* RIGHT COLUMN — Teacher OR Support Staff */}
                    <div className="col-sm-6">
                      {role_id == 5 && (
                        <>
                          <label className="form-label text-primary mb-2 font-weight-semibold">
                            Teacher Checks
                          </label>

                          {Object.entries(stateData.state_check.teacher_checks).map(
                            ([key], index) => (
                              <div className="form-check form-switch mb-2" key={index}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id={`teacher-${key}`}
                                  checked={!!checks.teacher[key]}
                                  onChange={(e) =>
                                    setChecks((prev) => ({
                                      ...prev,
                                      teacher: {
                                        ...prev.teacher,
                                        [key]: e.target.checked,
                                      },
                                    }))
                                  }
                                />
                                <label
                                  className="form-check-label text-primary font-weight-semibold"
                                  htmlFor={`teacher-${key}`}
                                >
                                  Teacher {key.replace(/_/g, " ")}
                                </label>
                              </div>
                            )
                          )}
                        </>
                      )}

                      {role_id == 6 && (
                        <>
                          <label className="form-label text-primary mb-2 font-weight-semibold">
                            Support Staff Checks
                          </label>

                          {Object.entries(stateData.state_check.support_staff_checks).map(
                            ([key], index) => (
                              <div className="form-check form-switch mb-2" key={index}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id={`support-${key}`}
                                  checked={!!checks.support_staff[key]}
                                  onChange={(e) =>
                                    setChecks((prev) => ({
                                      ...prev,
                                      support_staff: {
                                        ...prev.support_staff,
                                        [key]: e.target.checked,
                                      },
                                    }))
                                  }
                                />
                                <label
                                  className="form-check-label text-primary font-weight-semibold"
                                  htmlFor={`support-${key}`}
                                >
                                  Support Staff {key.replace(/_/g, " ")}
                                </label>
                              </div>
                            )
                          )}
                        </>
                      )}
                    </div>
                  </div>

                </div>
              </>
            )}

            {/* ---------- STEP 4 ---------- */}
            {step === 4 && apiResult && (
              <div className="mt-4">
                <h4 className="text-success mb-3">Verification Result</h4>

                <h6 className="text-primary mb-3">
                  <strong>Message: </strong>
                        {apiResult?.message}
                      </h6>

                {apiResult.scores?.map((item, index) => {
                  const [documentKey, documentResult] = Object.entries(item)[0];

                  const readableName = documentKey
                    .replace(/_/g, " ")          // underscores → space
                    .replace(/\b\w/g, (l) => l.toUpperCase());

                  return (
                    <div className="card p-3 mb-3" key={index}>
                      <h6 className="text-primary mb-3">
                        {readableName}
                      </h6>

                      <div className="row g-3">
                        <div className="col-md-4">
                          <strong>Acknowledged:</strong>
                          <div className="d-flex align-items-center gap-2">
                            {(documentResult?.is_approve || "NO").toUpperCase() === "YES" ? (
                              <>
                                <span className="text-success">YES</span>
                                <i className="fa fa-check text-success" />
                              </>
                            ) : (
                              <>
                                <span className="text-danger">NO</span>
                                <i className="fa fa-times text-danger" />
                              </>
                            )}
                          </div>

                        </div>

                        <div className="col-md-4">
                          <strong>Score:</strong>
                          <div>{documentResult.score}</div>
                        </div>

                        <div className="col-md-4">
                          <strong>Expiry Date:</strong>
                          <div>{documentResult.expiry_date}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                <div className="text-end mt-4">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      shouldRedirectRef.current = true;
                      window.bootstrap.Modal.getOrCreateInstance(
                        document.getElementById("addComplianceModal")
                      ).hide();
                    }}
                  >
                    Finish
                  </button>
                </div>
              </div>
            )}


            {/* ---------- NAV ---------- */}
            {step <= 4 && (
              <div className="d-flex justify-content-between mt-4">
                {step > 1 && (
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={prevStep}
                  >
                    ← Back
                  </button>
                )}

                {step < 3 && (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={nextStep}
                  >
                    Continue →
                  </button>
                )}

                {step === 3 && (
                  <button
                    type="button"
                    className="btn btn-light-header px-5"
                    disabled={saveLoading}
                    onClick={handleSubmit}
                  >
                    {saveLoading ? (
                      <span className="d-flex align-items-center justify-content-center">
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Saving...
                      </span>
                    ) : (
                      <span className="d-block">Save</span>
                    )}
                  </button>
                )}
              </div>
            )}

          </form>
        )}
      </div>
    </div>
  );
});

export default WorkerAddCompliance;
